@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner
      class="mat-spinner-color"
      mode="indeterminate"
    ></mat-progress-spinner>
  </div>
}
<div style="display:flex;">
  <button class="mat-close-btn" style="top:1.5rem;right:1rem;" mat-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <h2 mat-dialog-title style="margin:0px;width:50%;">List of System Super Admins</h2>
  <!-- <button mat-mini-fab matTooltip="Add Admin" (click)="addAdminPopup()" style="display: block;margin-left: auto;margin-right: 2rem;">
  <mat-icon class="matclass">add</mat-icon>
</button> -->
</div>
<mat-dialog-content>
  <!-- <mat-form-field appearance="fill" class="filter-position">
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Type to search any" #input>
</mat-form-field> -->
<div class="table-container mat-elevation-z8">
  <custom-table
    [tableData]="dataSource.data"
    [tableColumns]="tableColumns"
    [tableActions]="tableActions"
    [isLoading]="isLoading"
    isFilterPresent="true"
    [filterAttributes]="filterAttributes"
    hideTableTitle="true"
    [tableTitle]="'Admins'"
    moduleType="admin"
    pageType="manage-system-admins"
    (toogleEmitter)="onToggleChange($event)"
    [handleToggleInParent]="true"
    (tableActionEmitter)="tableActionEmitter($event)"
    (rowAction)="rowAction($event)"
    [showBreadcrumb]="false"
    >
  </custom-table>
</div>
</mat-dialog-content>
